import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { db } from '@vibe/db/server';
import { staffUsers } from '@generated/models';
import { verifyStaffMember } from '@generated/server/staff.server';

const NOT_STAFF = { isStaff: false, userId: null as string | null, name: null as string | null };

// Recognise the viewer and register their monday user ID on first visit.
export const getViewerAccess = createServerFn({ method: 'POST' })
  .validator(z.object({ userId: z.string().min(1), accountId: z.string().min(1) }))
  .handler(async ({ data }) => {
    try {
      const member = await verifyStaffMember(data.userId, data.accountId);
      if (!member) return NOT_STAFF;

      const now = new Date().toISOString();
      try {
        const existing = await db.collection(staffUsers).where('userId', '==', member.id).limit(1).get();
        const doc = existing[0];
        if (doc) {
          await db.collection(staffUsers).doc(doc.id).update({ lastSeenAt: now, name: member.name });
        } else {
          await db.collection(staffUsers).add({
            userId: member.id,
            name: member.name,
            firstSeenAt: now,
            lastSeenAt: now
          });
        }
      } catch (err) {
        console.error('Staff registration failed:', err);
      }

      return { isStaff: true, userId: member.id, name: member.name };
    } catch (err) {
      console.error('Viewer access check failed:', err);
      return NOT_STAFF;
    }
  });
